import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { Card, Row, Col, Upload, Button, Progress, notification, Radio, Typography } from 'antd';

import ItemExcel01Actions from '../../Stores/ItemExcel01/Actions';

const { Text } = Typography;

class ItemExcel01Screen extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      group: 'no_group',
      fileList: []
    };

    this.useOnUpload = this.useOnUpload.bind(this);
    this.useOnDownload = this.useOnDownload.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {
    const { uploadIsLoading, showBatchJobStatus } = this.props;

    if (uploadIsLoading) {
      setTimeout(() => {
        showBatchJobStatus();
      }, 10000);
    }
  }

  componentWillUnmount() {}

  useOnUpload() {
    const { uploadExcel } = this.props;
    const { fileList } = this.state;

    if (fileList.length > 0) {
      uploadExcel(fileList[0]);
    }
  }

  useOnDownload() {
    const { downloadExcel } = this.props;
    const { group } = this.state;

    downloadExcel(group);
  }

  render() {
    const { intl, uploadIsLoading, batchJobStatus } = this.props;
    const { fileList, group } = this.state;

    const groupOptions = [
      <Radio.Button key="no_group" value="no_group">
        {intl.formatMessage({ id: 'no_group' })}
      </Radio.Button>,
      <Radio.Button key="item_group_01_code" value="item_group_01_code">
        {intl.formatMessage({ id: 'brand' })}
      </Radio.Button>,
      <Radio.Button key="item_group_02_code" value="item_group_02_code">
        {intl.formatMessage({ id: 'category' })}
      </Radio.Button>,
      <Radio.Button key="item_group_03_code" value="item_group_03_code">
        {intl.formatMessage({ id: 'manufacturer' })}
      </Radio.Button>
    ];

    return (
      <Card>
        <Row type="flex" justify="center" gutter={[0, 8]}>
          <Col span={3}>
            <Text>{intl.formatMessage({ id: 'sheet' })}</Text>
          </Col>
          <Col span={1}>
            <Text>:</Text>
          </Col>
          <Col span={20}>
            <Radio.Group
              onChange={e => {
                this.setState({
                  group: e.target.value
                });
              }}
              name="group"
              value={group}
            >
              {groupOptions}
            </Radio.Group>
          </Col>
        </Row>
        <Row type="flex" justify="start" gutter={[0, 8]}>
          <Col span={12}>
            <Upload
              disabled={uploadIsLoading}
              onRemove={() => {
                this.setState({
                  fileList: []
                });
              }}
              beforeUpload={file => {
                // const validFileName = 'ITEM_EXCEL_01';
                const validFileName = 'ITEM';
                if (file && file.name.toLowerCase().includes(validFileName.toLowerCase())) {
                  this.setState({
                    fileList: [file]
                  });
                } else {
                  notification.error({
                    message: `${intl.formatMessage({
                      id: 'invalid_file_name_must_contain'
                    })} ${validFileName}`,
                    duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
                  });
                }

                return false;
              }}
              fileList={fileList}
            >
              <Button type="primary" loading={uploadIsLoading}>
                {intl.formatMessage({ id: 'browse' })}
              </Button>
            </Upload>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              onClick={this.useOnUpload}
              disabled={fileList.length === 0}
              loading={uploadIsLoading}
            >
              {intl.formatMessage({ id: 'upload' })}
            </Button>
            <Button type="primary" onClick={this.useOnDownload} loading={uploadIsLoading}>
              {intl.formatMessage({ id: 'download' })}
            </Button>
          </Col>
        </Row>
        <Row type="flex" justify="center" gutter={[0, 8]}>
          <Col span={24}>
            <Progress percent={parseInt(batchJobStatus.status_number, 10)} />
          </Col>
        </Row>
      </Card>
    );
  }
}

ItemExcel01Screen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  batchJobStatus: PropTypes.shape({
    status_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  uploadIsLoading: PropTypes.bool,

  showBatchJobStatus: PropTypes.func,
  uploadExcel: PropTypes.func,
  downloadExcel: PropTypes.func
};

ItemExcel01Screen.defaultProps = {
  intl: {},

  batchJobStatus: {
    status_number: '0'
  },
  uploadIsLoading: false,

  showBatchJobStatus() {},
  uploadExcel() {},
  downloadExcel() {}
};

const mapStateToProps = state => ({
  batchJobStatus: state.itemExcel01.batchJobStatus,
  uploadIsLoading: state.itemExcel01.uploadIsLoading
});

const mapDispatchToProps = dispatch => ({
  showBatchJobStatus: () => dispatch(ItemExcel01Actions.itemExcel01ShowBatchJobStatus()),
  uploadExcel: file => dispatch(ItemExcel01Actions.itemExcel01UploadExcel(file)),
  downloadExcel: group => dispatch(ItemExcel01Actions.itemExcel01DownloadExcel(group))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ItemExcel01Screen));
